import { render } from "./OperationsComponent.vue?vue&type=template&id=38097a16&scoped=true"
import script from "./OperationsComponent.vue?vue&type=script&lang=js"
export * from "./OperationsComponent.vue?vue&type=script&lang=js"

import "./OperationsComponent.vue?vue&type=style&index=0&id=38097a16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38097a16"]])

export default __exports__